import React from 'react';
import { firestore } from '../firebase';
import * as RFIcon from 'react-feather'; 
import language from '../languages';
import buildQuery from "./EntityUtil";
import * as Yup from 'yup';
import { EditorState, convertToRaw } from 'draft-js';
import moment from "moment";

const meta = (lang) => {
    return {
        entityName: 'Blogs',
        entityTitle: 'Blogs',
        headerIcon: <RFIcon.Clipboard strokeWidth={2} />,
        emptyRow: () => {
            return {
                title: '',
                description: '',
                content: JSON.stringify(convertToRaw(EditorState.createEmpty().getCurrentContent())),
                image: 'https://via.placeholder.com/800',
                status: 'DRAFT',
                publishDate: moment(new Date()).unix(),
            }
        },
        collection: 'blogs',
        // addButtonText: () => {
        //     return <>Add New </>
        //     },
        addButtonText: language[lang].New_Article,
        fields: [
            { name: 'title', default: null, dataType: 'string', label: 'Blog Title', input: 'text' },
            { name: 'description', default: null, dataType: 'string', label: 'Short Description', input: 'text', multiline: true, rows: 3 },
            { name: 'content', default: null, dataType: 'string', label: 'Content', input: 'editor'},
            { name: 'image', default: null, dataType: 'string', label: 'Image', input: 'file'},
            {
                name: 'status', default: null, dataType: 'string', label: 'Status', input: 'select',
                getItems: () => {
                    return new Promise((resolve, reject)=> {
                        firestore.collection('lookups').where('code', '==', 'BLOG_STATUS').get().then(snapshot=>{
                            snapshot.forEach(doc=>{
                                const row = doc.data();
                                const items = row.values.map(item=> ({label: item.label, value: item.value}));
                                resolve(items);
                            })
                        });
                    });
                    // return [{ value: 'DRAFT', label: 'Draft' }, { value: 'RELEASED', label: 'Released' }, { value: 'EXPIRED', label: 'Expired' }]
                },
                required: true
            },
            { name: 'publishDate', default: null, dataType: 'timestamp', label: 'Publish Date', input: 'datetime' }
        ],
        table: [
            {name: 'image', type: 'field', label: 'Image',
                render: (doc)=> {
                    return (
                        <img component="span" alt={doc.title} src={doc.image} style={{height:75}} />
                    )}
            },
            { name: 'title', type: 'field', label: 'Title' },
            { name: 'status', type: 'field', label: 'Status' },
            { name: 'publishDate', type: 'field', label: 'Publish Date' },
            { name: 'actions', type: 'action', label: 'Actions', actions: ['delete', 'edit'] }
        ],
        validationSchema: Yup.object({
            title: Yup.string()
                .required(language[lang].Field_Required),
            description: Yup.string()
                .required(language[lang].Field_Required),
            content: Yup.string()
                .required(language[lang].Field_Required),
            image: Yup.string()
                .required(language[lang].Field_Required),
            status: Yup.string()
                .required(language[lang].Field_Required),
            publishDate: Yup.date()
                .required(language[lang].Field_Required),
        }),
        filterObject: [{
            label: 'Status',
            name: 'status',
            type: 'checkbox',
            items: ()=> {
                return new Promise((resolve, reject)=> {
                    firestore.collection('lookups').where('code', '==', 'BLOG_STATUS').get().then(snapshot=>{
                        snapshot.forEach(doc=>{
                            const row = doc.data();
                            const items = row.values.map(item=> ({label: item.label, value: item.value, selected: false}));
                            resolve(items);
                        })
                    });
                });
            }
        }],
        getQuery: (paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage) => {
            let query = {};
            query = firestore.collection('blogs');
            return buildQuery(query, paginationAction, firstRowRef, lastRowRef, filter, searchTerms, orderBy, itemsPerPage);
        },
        defaultOrderBy: ['_createdOn', 'desc'],
        searchableColumns: ['title'],
        beforeSave: (user, doc) => {
            return doc
        }
    }
}

export default meta;